import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

type OrderLike = {
  order_number?: string | null;
  status?: string | null;
  fulfillment_type?: string | null;
  dine_in_qr_token?: string | null;
};

function showCode(order: OrderLike) {
  const status = String(order.status || '').toLowerCase();
  if (status === 'completed' || status === 'cancelled' || status === 'refunded') return false;
  const type = String(order.fulfillment_type || 'pickup').toLowerCase();
  return type !== 'dine_in' && type !== 'delivery';
}

/** The café scans this. The token is signed on the server. */
export default function OrderDineInCode({ order }: { order: OrderLike }) {
  if (!showCode(order)) return null;
  const token = order.dine_in_qr_token || '';
  return (
    <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-3 text-center">
      <p className="text-sm font-semibold text-amber-950">Show this at the café for dine-in</p>
      <p className="mt-1 text-xs text-amber-900">
        The order stays pickup price until the café scans it. The discount is applied on the server.
      </p>
      {token ? (
        <div className="mt-3 flex justify-center">
          <QRCodeSVG value={token} size={148} includeMargin />
        </div>
      ) : (
        <p className="mt-3 text-xs text-amber-900">
          The QR code is not available right now. Give the café the order code.
        </p>
      )}
      {order.order_number && (
        <p className="mt-2 font-mono text-sm font-bold text-amber-950">Order code {order.order_number}</p>
      )}
    </div>
  );
}
